import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.css']
})
export class LoadingScreenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.sendFinishedMessage();
    console.log("loading triggered")
    localStorage.setItem("previewExited", "true")
  }

  sendFinishedMessage() {
    window.parent.postMessage({ type: 'customEvent', data: 'Hello from iframe' }, '*');
  }
  

}
